import { CURRENCY, DISPLAY_ROUNDING_UNIT, LOCALE_BY_CURRENCY } from "../constants/currency";
import { LOCALES } from "../constants/locales";
import { getCurrencyFromLocalStorage, getCurrentUserFromLocalStorage } from "./localStorageHelper";

export const intlNumberFormat = (currencyCode) => {
  const cfg = LOCALE_BY_CURRENCY[currencyCode]
    || { locale: LOCALES.ENUS, minimumFractionDigits: 0, maximumFractionDigits: 2 };

  return new Intl.NumberFormat(cfg.locale, {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits: cfg.minimumFractionDigits,
    maximumFractionDigits: cfg.maximumFractionDigits,
  });
};

export const roundDownToUnit = (value, currencyCode) => {
  if (value == null || Number.isNaN(Number(value))) return value;
  const unit = DISPLAY_ROUNDING_UNIT[currencyCode];
  if (!unit || unit <= 1) return value;
  const sign = value < 0 ? -1 : 1;
  return sign * Math.floor(Math.abs(value) / unit) * unit;
};

export const convertCurrency = (amount, from, to, rates) => {
  if (!rates || !rates[from.toLowerCase()] || !rates[to.toLowerCase()]) {
    throw new Error("Invalid rates data");
  }
  const defaultAmount = amount / rates[from.toLowerCase()];
  const result = defaultAmount * rates[to.toLowerCase()];

  if (to === CURRENCY.KRW || to === CURRENCY.VND) {
    return Math.round(result);
  } else {
    return parseFloat(result.toFixed(2));
  }
};

export const getCurrency = () => {
  const currentUser = getCurrentUserFromLocalStorage();
  if (currentUser) {
    return currentUser.currency || CURRENCY.KRW;
  }
  const currentCurrency = getCurrencyFromLocalStorage();
  return currentCurrency || CURRENCY.KRW;
};

export function formatAbbrevCurrency(
  rawAmount,
  displayCurrency,
  ratesData,
  defaultCurrency
) {
  if (rawAmount == null) return "";

  let valueInDisplay = rawAmount;
  const fromKey = defaultCurrency.toLowerCase();
  const toKey = displayCurrency.toLowerCase();
  if (
    ratesData &&
    ratesData[fromKey] != null &&
    ratesData[toKey] != null &&
    defaultCurrency !== displayCurrency
  ) {
    const rateFrom = ratesData[fromKey];
    const rateTo = ratesData[toKey];
    valueInDisplay = (rawAmount / rateFrom) * rateTo;
  }

  valueInDisplay = roundDownToUnit(valueInDisplay, displayCurrency);

  const absVal = Math.abs(valueInDisplay);
  let shortNum;
  let suffix;
  if (absVal >= 1e6) {
    shortNum = Math.round(valueInDisplay / 1e6);
    suffix = "M";
  } else if (absVal >= 1e3) {
    shortNum = Math.round(valueInDisplay / 1e3);
    suffix = "K";
  } else {
    shortNum = Math.round(valueInDisplay);
    suffix = "";
  }

  const cfg = LOCALE_BY_CURRENCY[displayCurrency] || {};
  const nf = new Intl.NumberFormat(cfg.locale, {
    style: "currency",
    currency: displayCurrency,
    minimumFractionDigits: cfg.minimumFractionDigits,
    maximumFractionDigits: cfg.maximumFractionDigits,
  });
  const parts = nf.formatToParts(0);
  const symbolPart = parts.find((p) => p.type === "currency")?.value || "";

  const prefixList = [CURRENCY.USD, CURRENCY.KRW];
  const needsPrefix = prefixList.includes(displayCurrency);

  if (needsPrefix) {
    return `${symbolPart}${shortNum}${suffix}`;
  } else {
    return `${shortNum}${suffix} ${symbolPart}`;
  }
}
